module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-69.a3974df2.svg";